import { TextInput } from '@optimus-web/core';
import { inject } from './inject';

export const PaymentCardHolderName = inject(TextInput);
